import mainLogo from "../assets/squaber-icon-yellow-300-300.png";
import textLogo from "../assets/squaber-logo-text.png";

export default {
  main: mainLogo,
  text: textLogo,
  loginAspectRatio: 0.25
};
